var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchServerFallback } from "../api";
import { parsePreviewMetadata } from "./xRenderMetadataHeaderParser";
export function getPreviewMetadataFromFallback(item, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        // strip all transforms from the item, we need the preview box
        const itemClone = Object.assign({}, item);
        itemClone.rotationAngle = undefined;
        itemClone.scale = undefined;
        itemClone.skew = undefined;
        itemClone.transform = undefined;
        itemClone.transforms = undefined;
        const panel = {
            id: "preview-0",
            name: "preview-0",
            width: "1mm",
            height: "1mm",
            decorationTechnology: options.decoTech,
        };
        if (options.itemInfo.itemType === "textArea") {
            panel.textAreas = [itemClone];
        }
        else if (options.itemInfo.itemType === "subpanel") {
            panel.subpanels = [itemClone];
        }
        else {
            throw new Error("Unsupported item type for preview box fallback");
        }
        const cimdoc = {
            version: "2.0",
            fontRepositoryUrl: options.fontRepositoryUrl,
            document: {
                definitions: (_a = options.definitionTreeNode) === null || _a === void 0 ? void 0 : _a.definition,
                colorPalette: options.colorPalette,
                panels: [panel],
            },
        };
        cimdoc.document.panels = [panel];
        const fallback = yield fetchServerFallback({
            document: cimdoc,
            pixelSize: options.pixelSize,
            instructionType: "item",
            overprint: undefined,
            referrer: options.referrer,
        });
        if (fallback.xRenderMetadataHeader === undefined) {
            throw Error("Missing x-render-metadata header");
        }
        return parsePreviewMetadata(fallback.xRenderMetadataHeader);
    });
}
//# sourceMappingURL=getFallbackItem.js.map